var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"form",scopedSlots:_vm._u([{key:"default",fn:function(slot){return [_vm._t("default",null,null,slot)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }